import { render } from "./RelatorioCurvaABCIndex.vue?vue&type=template&id=0da22945&scoped=true&ts=true"
import script from "./RelatorioCurvaABCIndex.vue?vue&type=script&lang=ts"
export * from "./RelatorioCurvaABCIndex.vue?vue&type=script&lang=ts"

import "./RelatorioCurvaABCIndex.vue?vue&type=style&index=0&id=0da22945&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da22945"]])

export default __exports__